import './newUser.css';

export default function () {
    return (
        <div className='newUser'>
            <h1 className='newUserTitle'>New User</h1>
            <form className="newUserForm">
                <div className="newUserItem">
                    <label>Username</label>
                    <input type="text" placeholder='john' />
                </div>
                <div className="newUserItem">
                    <label>Full Name</label>
                    <input type="text" placeholder='john Smith' />
                </div>
                <div className="newUserItem">
                    <label>Email</label>
                    <input type="email" placeholder='johnSmith@gamil.com' />
                </div>
                <div className="newUserItem">
                    <label>Password</label>
                    <input type="password" placeholder='Password' />
                </div>
                <div className="newUserItem">
                    <label>Phone</label>
                    <input type="text" placeholder='+1 2334 543545 4564' />
                </div>
                <div className="newUserItem">
                    <label>Adress</label>
                    <input type="text" placeholder='New York | USA' />
                </div>
                <div className="newUserItem">
                    <div className="newUserGender">
                        <label>Gender</label>
                        <input type="radio" placeholder='gender' id='male' value='male' />
                        <label for="male">Male</label>
                        <input type="radio" placeholder='gender' id='female' value='female' />
                        <label for="female">Female</label>
                        <input type="radio" placeholder='gender' id='other' value='other' />
                        <label for="other">Other</label>
                    </div>
                </div>
                <div className="newUserItem">
                    <label>Active</label>
                    <select className='newUserSelect' name="active" id="active">
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                    </select>
                </div>
                <button className='newUserButton'>Create</button>
            </form>
        </div>
    )
}